import { Moon, Sun, Monitor } from 'lucide-react';
import { useAppStore } from '../../contexts/store';
import Button from './Button';

export function ThemeToggle() {
  const { theme, setTheme } = useAppStore();

  const cycleTheme = () => {
    const themes: Array<'light' | 'dark' | 'system'> = ['light', 'dark', 'system'];
    const currentIndex = themes.indexOf(theme);
    const nextIndex = (currentIndex + 1) % themes.length;
    setTheme(themes[nextIndex]);
  };

  const Icon = theme === 'light' ? Sun : theme === 'dark' ? Moon : Monitor;

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={cycleTheme}
      aria-label="Toggle theme"
      title={`Current theme: ${theme}`}
    >
      <Icon size={18} />
    </Button>
  );
}
